module.exports = __webpack_public_path__ + "static/webbroll_2lg-6a5b7e5fcdf28abf980a0cc9434a566d.jpg";